// extracted by mini-css-extract-plugin
export default {"secondary-navigation":"tabsNav_secondary-navigation__PfYK+","secondaryNavigation":"tabsNav_secondary-navigation__PfYK+","mobSidebarBtn":"tabsNav_mobSidebarBtn__WM5G-"};